import { render, staticRenderFns } from "./Nuevo-punto-de-venta.vue?vue&type=template&id=50e314fe"
import script from "./Nuevo-punto-de-venta.vue?vue&type=script&lang=js"
export * from "./Nuevo-punto-de-venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports